module.exports = __webpack_public_path__ + "img/course4.5174ed4e.png";